import { DataservicefavorisService } from './../../../../service/dataservicefavoris.service';
import { ToastrService } from 'ngx-toastr';
import { DOCUMENT } from '@angular/common';
import { Component, ElementRef, HostListener, Inject, OnInit, ViewChild, Input } from '@angular/core';

import { SearchService } from 'app/layout/components/navbar/navbar-search/search.service';
import { ApiService } from 'app/auth/helpers/apiservice';
import { User } from 'app/auth/models';
import { Router } from '@angular/router';
import { CoreConfigService } from '@core/services/config.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalSpinnerComponent } from 'app/main/pages/modal-spinner/modal-spinner.component';
import { timerRedo } from 'app/utils/timer';
import { ToastService } from 'app/service/toast.service';

@Component({
  selector: 'app-navbar-bookmark',
  templateUrl: './navbar-bookmark.component.html'
})
export class NavbarBookmarkComponent implements OnInit {
  @Input() hiddenMenu;
  // Public
  public bookmarkText = '';
  public openBookmarkRef = false;
  public activeIndex = 0;
  public apiData;
  public pages = [];
  public myserviceFavoris 
  public myFavorisItems :any;
  public bookmarkSearchLimit;
  public bookmarkedItems;
  public items= [];
  public currentUser: User;

  // Decorator
  @ViewChild('openBookmark') private _bookmarkElement: ElementRef;
  @HostListener('keydown.escape') fn() {
    this.removeOverlay();
    this.openBookmarkRef = false;
    this.bookmarkText = '';
  }
  @HostListener('document:click', ['$event']) clickout(event) {
    // Close Bookmark if Clicked on Overlay
    if (event.target.className === 'content-overlay') {
      this.removeOverlay();
      this.openBookmarkRef = false;
      this.bookmarkText = '';
    }

    // Close Bookmark if clicked Outside of Container
    if (!(event.target.nodeName === 'INPUT') && this.openBookmarkRef === true) {
      this.removeOverlay();
      this.openBookmarkRef = false;
      this.bookmarkText = '';
    }
  }
  config :any;
  /**
   *
   * @param document
   * @param _searchService
   */
  constructor(@Inject(DOCUMENT) private document, 
  public _searchService: SearchService,
   private toastr: ToastrService,private toast: ToastService, private ApiSrv: ApiService,
   private dataservice: DataservicefavorisService,private _router: Router, private _config: CoreConfigService,
   private modal : NgbModal) {
      this.config = this._config.getConfig();
      this.config.subscribe(x => this.hiddenMenu = x.layout.menu.hidden === true);    
   }

  // Public Methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Add Bookmark
   *
   * @param id
   */
  addBookmark(id) {
    const index = this.pages.findIndex(object => {
      return object.id === id;
    });
    this.pages[index].is_favoris = true;
    this.bookmarkedItems.push(this.pages[index]);
    this.items = this.bookmarkedItems.map(item => item.id);
    this.updateListeFavoris(this.items, ' ajouté ', '' , index,'1');
    
  }

  /**
   * Remove Bookmark
   *
   * @param id
   */
  removeBookmark(id) {
    const index = this.pages.findIndex(object => {
      return object.id === id;
    });
    const index2 = this.bookmarkedItems.findIndex(object => {
      return object.id === id;
    });
    this.pages[index].is_favoris = false;
    this.bookmarkedItems.splice(index2, 1);
    this.items = this.bookmarkedItems.map(item => item.id);
   this.updateListeFavoris(this.items,' retiré ', ' de ', index,'1');
  }


  updateListeFavoris(liste_service, operation,text, index,etat ){
    const params = {
      liste_service: JSON.stringify(liste_service),
    }
    const data = {
      schema_webservice: '/servicesFavoris/update',
      params,
    }
    this.ApiSrv.api(data).subscribe((res) => {      
      if (res.code === '00' ){
        this.myserviceFavoris = res.myServicesFavoris;
        if (etat != '0') {
          this.toastr.info('Le service '+ this.pages[index].subName +' est '+  operation + text + ' la liste de favoris', 'Information', {
            toastClass: 'toast ngx-toastr',
            closeButton: true
          });         
        }else {
          this.bookmarkedItems = this.pages.filter(page => page.is_favoris === true);
          this.bookmarkSearchLimit = this.apiData.allServices.bookmarkLimit;
          this._searchService.onIsBookmarkOpenChange.subscribe(res => {
            this.openBookmarkRef = res;
          }); 
        }   
        this.dataservice.data = res.myServicesFavoris;
      }else if (res.code === "01") {
        this.toast.error(res.message);
      }
    });
  }
  /**
   * Open Bookmark
   */
  openBookmark() {
    this.openBookmarkRef = true;
    this._searchService.onIsBookmarkOpenChange.next(this.openBookmarkRef);
  }

  /**
   * Close Bookmark
   */
  closeBookmark() {
    this.openBookmarkRef = false;
    this._searchService.onIsBookmarkOpenChange.next(this.openBookmarkRef);
  }

  /**
   * Remove Overlay
   */
  removeOverlay() {
    this.document.querySelector('.app-content').classList.remove('show-overlay');
  }

  /**
   * Next Active Match
   */
  nextActiveMatch() {
    this.activeIndex = this.activeIndex < this.bookmarkSearchLimit - 1 ? ++this.activeIndex : this.activeIndex;
  }

  /**
   * Previous Active Match
   */
  prevActiveMatch() {
    this.activeIndex = this.activeIndex > 0 ? --this.activeIndex : 0;
  }

  /**
   * Auto Suggestion
   *
   * @param event
   */
  autoSuggestion(event) {
    if (38 === event.keyCode) {
      return this.prevActiveMatch();
    }
    if (40 === event.keyCode) {
      return this.nextActiveMatch();
    }
  }

  /**
   * Toggle Bookmark
   *
   * @param id
   */
  toggleBookmark(id) {
    const index = this.pages.findIndex(object => {
      return object.id === id;
    });
    if (this.pages[index].is_favoris === true) {
      if(this.bookmarkedItems.length <= 4){
        this.toastr.error("vous devez garder 4 services au minimum ", 'Erreur!', {
          toastClass: 'toast ngx-toastr',
          closeButton: true
        });
      }else {
        this.removeBookmark(id);
      }
    } else {
      this.addBookmark(id);
    }
  }

  /**
   * Toggle Bookmark Popup
   */
  toggleBookmarkPopup() {
    setTimeout(() => {
      if (this.openBookmarkRef === false) {
        this.openBookmark();
      } else {
        this.closeBookmark();
      }
      setTimeout(() => {
        this._bookmarkElement.nativeElement.focus();
      }, 0);
    }, 0);
  }

  /**
   * Update Bookmark
   *
   * @param event
   */
  bookmarkUpdate(event) {
    const val = event.target.value.toLowerCase();
    if (val !== '') {
      this.document.querySelector('.app-content').classList.add('show-overlay');
    } else {
      this.document.querySelector('.app-content').classList.remove('show-overlay');
    }
    this.autoSuggestion(event);
  }

  // Lifecycle Hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
   
    setTimeout(() => {
    if(this.currentUser && !this.hiddenMenu){
        const data = {
          schema_webservice: '/servicesFavoris/getAllServices',
        }
        this.ApiSrv.api(data).subscribe((res) => {
          if (res.code === '00'){
            this.apiData = res;
            this.pages = this.apiData.allServices;
            this.myFavorisItems=  this.apiData.myFavorisItems;
            if(this.myFavorisItems == 0){
              for (let index = 0; index < this.pages.length; index++) {
                this.items.push(this.pages[index].id);
                this.pages[index].is_favoris = true;
                
              }
              this.bookmarkedItems = this.pages.map(item => item.is_favoris === true);
              this.updateListeFavoris(this.items,' retiré ', ' du ', "yjk",'0');
            }
            else{
              this.bookmarkedItems = this.pages.filter(page => page.is_favoris === true);
              this.bookmarkSearchLimit = this.apiData.allServices.bookmarkLimit;
              this._searchService.onIsBookmarkOpenChange.subscribe(res => {
                this.openBookmarkRef = res;
              }); 
            }
          }else if (res.code === "01") {
            this.toast.error(res.message);
          }else if (res.code === '08') {
            const modalRef = this.modal.open(ModalSpinnerComponent, { centered: true,backdrop: "static", windowClass:'custommodal' });
            setTimeout(() => {
              modalRef.dismiss();
              this.ngOnInit();
            }, timerRedo);
          }
        });
      }
    }, 1500);
    
  }
}
